<template>
  <div>
    <transition
      name="animate__fadeInOut"
      enter-active-class="animate__animated animate__fadeIn"
      appear
    >
      <b-row
        class="mainRow"
        style="font-size: 0.8rem; font-weight: bold; text-align: center"
      >
        <b-col
          cols="3"
          class="visually-hidden"
          v-if="
            !(
              getIsCompName === 'tether' ||
              getIsCompName === 'cardToCard' ||
              getIsCompName === 'tron' ||
              getIsCompName === 'shaparak'
            )
          "
          >ثبت نام
        </b-col>
        <b-col
          cols="3"
          class="visually-hidden"
          :class="{
            'col-6':
              getIsCompName === 'tether' ||
              getIsCompName === 'cardToCard' ||
              getIsCompName === 'tron' ||
              getIsCompName === 'shaparak',
          }"
        >
          تاییدیه
        </b-col>
        <b-col
          cols="3"
          class="visually-hidden"
          :class="{
            'col-6':
              getIsCompName === 'tether' ||
              getIsCompName === 'cardToCard' ||
              getIsCompName === 'tron' ||
              getIsCompName === 'shaparak',
          }"
        >
          {{
            getIsCompName === "tether" || "tron"
              ? "اطلاعات پرداخت"
              : "نمایش کارت مقصد"
          }}
        </b-col>
        <b-col
          cols="3"
          class="visually-hidden"
          v-if="
            !(
              getIsCompName === 'tether' ||
              getIsCompName === 'cardToCard' ||
              getIsCompName === 'tron' ||
              getIsCompName === 'shaparak'
            )
          "
        >
          پرداخت
        </b-col>
      </b-row>
    </transition>
    <transition
      name="animate__fadeInOut"
      enter-active-class="animate__animated animate__fadeIn"
      appear
    >
      <b-row class="secondRow">
        <b-col
          cols="3"
          class="stepperColumn"
          :class="{
            'col-6': getIsCompName !== 'shetab',
          }"
        >
          <span :class="{ activeStepper: getStepperPage == 'pageOne' }">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              style="margin-right: -6px; position: absolute; margin-top: -1px"
              fill="currentColor"
              class="bi bi-circle"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
              />
            </svg>
          </span>
          <span
            class="stepper1"
            :class="{ activeStepper: getStepperPage === 'pageOne' }"
            >1</span
          >
          <div
            id="active-border1"
            :class="{
              activeBorder: getStepperPage === 'pageOne',
              borderDisFromTop: innerWidthLg(),
            }"
            style="
              position: absolute;
              background-color: lightgray;
              height: 4px;
              width: 10px;
            "
          ></div>
        </b-col>
        <b-col
          cols="3"
          :class="{
            'col-6': getIsCompName !== 'shetab',
          }"
        >
          <span
            id="svg1"
            :class="{
              activeStepper: getStepperPage === 'pageTwo',
              borderDisFromTop: innerWidthLg(),
            }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              style="margin-right: -6px; position: absolute; margin-top: -1px"
              fill="currentColor"
              class="bi bi-circle"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
              />
            </svg>
          </span>
          <span
            class="stepper2"
            :class="{ activeStepper: getStepperPage === 'pageTwo' }"
            >2</span
          >
        </b-col>
        <div
          id="active-border2"
          v-if="getIsCompName === 'shetab'"
          :class="{
            activeBorder: getStepperPage === 'pageTwo',
            borderDisFromTop: innerWidthLg(),
          }"
          style="
            position: absolute;
            top: 28px;
            background: lightgray;
            height: 4px;
            width: 10px;
          "
        ></div>
        <b-col cols="3" v-if="getIsCompName === 'shetab'">
          <span :class="{ activeStepper: getStepperPage === 'pageThree' }">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              style="margin-right: -6px; position: absolute; margin-top: -1px"
              fill="currentColor"
              class="bi bi-circle"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
              />
            </svg>
          </span>
          <span
            class="stepper3"
            :class="{ activeStepper: getStepperPage === 'pageThree' }"
            >3</span
          >
        </b-col>
        <div
          id="active-border3"
          v-if="getIsCompName === 'shetab'"
          :class="{
            activeBorder: getStepperPage === 'pageThree',
            borderDisFromTop: innerWidthLg(),
          }"
          style="
            position: absolute;
            top: 28px;
            background: lightgray;
            height: 4px;
            width: 10px;
          "
        ></div>
        <b-col cols="3" v-if="getIsCompName === 'shetab'">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              :class="{ activeStepper: getStepperPage === 'pageFour' }"
              width="20"
              height="20"
              style="margin-right: -6px; position: absolute;margin-top: -1px;}"
              fill="currentColor"
              class="bi bi-circle"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
              />
            </svg>
          </span>
          <span
            class="stepper4"
            :class="{ activeStepper: getStepperPage === 'pageFour' }"
            >4</span
          >
        </b-col>
      </b-row>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "shetabStepper",
  props: { whichPageIsIt: String },
  data() {
    return {
      paymentId: "",
    };
  },
  computed: {
    ...mapGetters(["getStepperPage", "getIsCompName", "getGatewayPendingFlag"]),
  },
  methods: {
    stepperActivateBorder() {
      let stepperCol = document.querySelector(".stepperColumn");
      let stepperNum1 = document.querySelector(".stepper1");
      let stepperNum2 = document.querySelector(".stepper2");
      let stepperNum3 = document.querySelector(".stepper3");
      let selectSvg = document.querySelector("#svg1");
      let selectedSvgTop = selectSvg ? selectSvg.offsetTop : 0;
      let stepperColWidth = stepperCol ? stepperCol.offsetWidth : 0;

      // Because steppers are different for tether and shetab
      if (this.getIsCompName === "shetab") {
        let stepperOffsetLeft1 = stepperNum1 ? stepperNum1.offsetLeft : 0;
        let stepperOffsetLeft2 = stepperNum2 ? stepperNum2.offsetLeft : 0;
        let stepperOffsetLeft3 = stepperNum3 ? stepperNum3.offsetLeft : 0;

        let activeBorder1 = document.querySelector("#active-border1");
        let activeBorder2 = document.querySelector("#active-border2");
        let activeBorder3 = document.querySelector("#active-border3");

        if (activeBorder1) {
          activeBorder1.style.top = selectedSvgTop + 7 + "px";
          activeBorder1.style.width = stepperColWidth - 17 + "px";
          activeBorder1.style.left =
            stepperOffsetLeft1 - stepperColWidth + 12 + "px";
        }

        if (activeBorder2) {
          activeBorder2.style.top = selectedSvgTop + 7 + "px";
          activeBorder2.style.width = stepperColWidth - 17 + "px";
          activeBorder2.style.left =
            stepperOffsetLeft2 - stepperColWidth + 12 + "px";
        }

        if (activeBorder3) {
          activeBorder3.style.top = selectedSvgTop + 7 + "px";
          activeBorder3.style.width = stepperColWidth - 18 + "px";
          activeBorder3.style.left =
            stepperOffsetLeft3 - stepperColWidth + 12 + "px";
        }
      }

      // Because steppers are different for tether and shetab
      if (this.getIsCompName !== "shetab") {
        let stepperOffsetLeft1 = stepperNum1 ? stepperNum1.offsetLeft : 0;
        let activeBorder1 = document.querySelector("#active-border1");

        if (activeBorder1) {
          activeBorder1.style.top = selectedSvgTop + 7 + "px";
          activeBorder1.style.width = stepperColWidth - 17 + "px";
          activeBorder1.style.left =
            stepperOffsetLeft1 - stepperColWidth + 12 + "px";
        }
      }
    },
    alignBodyCenter() {
      let pageHeight = document.querySelector("#app").offsetHeight;
      let windowHeight = window.innerHeight;
      if (window.innerHeight > 850) {
        document.querySelector("body").style.marginTop =
          (windowHeight - pageHeight) / 2 + "px";
      } else {
        document.querySelector("body").style.margin = 3 + "%";
      }
    },
    innerWidthLg() {
      if (innerWidth <= 1400) {
        return true;
      }
    },
  },
  created() {
    this.paymentId = this.$route.params.paymentId;
  },
  watch: {
    $route() {
      this.alignBodyCenter();
      this.stepperActivateBorder();
    },
    getGatewayPendingFlag() {
      this.alignBodyCenter();
      setTimeout(() => {
        this.stepperActivateBorder();
      }, 50);
    },
    getStepperPage() {
      this.alignBodyCenter();
      setTimeout(() => {
        this.stepperActivateBorder();
      }, 150);
    },
  },
  mounted() {
    this.alignBodyCenter();
    setTimeout(() => {
      this.stepperActivateBorder();
    }, 700);
    // align at every size
    window.addEventListener("resize", this.alignBodyCenter);
    window.addEventListener("resize", this.stepperActivateBorder);
  },
  destroyed() {
    // destroy event
    window.addEventListener("resize", this.alignBodyCenter);
    window.addEventListener("resize", this.stepperActivateBorder);
  },
};
</script>

<style scoped>
.activeBorder {
  background: #3d637d !important;
}

/*.borderDisFromTop{*/
/*  top: 45px !important;*/
/*}*/
.activeStepper {
  color: #3d637d !important;
}

.secondRow {
  font-size: 0.9rem;
  text-align: center;
  font-weight: bold;
  color: lightgray;
  padding-bottom: 6px;
}

@media only screen and (max-width: 992px) {
  .mainRow {
    padding-top: 5px;
  }

  .secondRow {
    padding-bottom: 0;
  }
}
</style>
